import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './src/App.jsx';
import './src/index.css';

// Initialize theme from localStorage or default to light mode
const storedTheme = localStorage.getItem('fastenai-theme');
if (storedTheme === 'dark') {
  document.documentElement.classList.add('dark');
} else {
  // Default to light mode (no dark class)
  document.documentElement.classList.remove('dark');
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
